/**
 * Session timeout utilities for handling authentication expiration
 */

export interface SessionTimeoutHandler {
  handleSessionTimeout: (reason?: string) => void;
}

// Global session timeout handler - will be set by AuthContext
let globalSessionTimeoutHandler: SessionTimeoutHandler | null = null;

/**
 * Register the global session timeout handler
 * This should be called by AuthContext during initialization
 */
export const registerSessionTimeoutHandler = (handler: SessionTimeoutHandler): void => {
  globalSessionTimeoutHandler = handler;
};

/**
 * Trigger session timeout from anywhere in the application
 * This will clear tokens and redirect to login with appropriate messaging
 */
export const triggerSessionTimeout = (reason = 'session_expired'): void => {
  console.warn('🔒 Session timeout triggered:', reason);

  if (globalSessionTimeoutHandler) {
    globalSessionTimeoutHandler.handleSessionTimeout(reason);
  } else {
    // Fallback if handler is not registered
    console.error('No session timeout handler registered, using fallback');
    sessionStorage.clear();
    window.location.href = `/login?reason=${reason}`;
  }
};

/**
 * Check if current navigation is due to session timeout
 */
export const getSessionTimeoutReason = (): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('reason');
};

/**
 * Clear session timeout reason from URL
 */
export const clearSessionTimeoutReason = (): void => {
  const url = new URL(window.location.href);
  url.searchParams.delete('reason');
  window.history.replaceState({}, '', url.toString());
};
